<template>
    <Teleport to="#modals" v-if="show">
        <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <!--
                  Background overlay, show/hide based on modal state.
                -->
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div
                        v-show="show"
                        @click="dismiss()"
                        class="fixed inset-0 bg-opacity-75 transition-opacity"
                        :class="{
                            'bg-gray-500': !dark,
                            'bg-gray-800': dark,
                            'backdrop-blur': withBlur,
                        }"
                        aria-hidden="true"
                    >
                        <canvas
                            id="modal-canvas-background"
                            width="1920"
                            height="532"
                            style="
                                display: block;
                                position: fixed;
                                pointer-events: none;
                                top: 0px;
                                width: 100vw;
                                height: 100vh;
                            "
                        ></canvas>
                    </div>
                </transition>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <!--
                  Modal panel, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <transition
                    enter-active-class="transition ease-out duration-300"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                >
                    <div
                        v-show="show"
                        :class="sizeClass"
                        class="transform inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6"
                    >
                        <div class="flex justify-between">
                            <div>
                                {{ title }}
                            </div>
                            <div class="">
                                <button
                                    type="button"
                                    @click="dismiss()"
                                    class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    <span class="sr-only">{{ $t('messages.close') }}</span>
                                    <IconX class="h-6 w-6" />
                                </button>
                            </div>
                        </div>
                        <div>
                            <slot />
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { IconX } from '@tabler/icons-vue';

export default {
    emits: ['close'],
    components: {
        IconX,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        dark: {
            type: Boolean,
            default: false,
            required: false,
        },
        withBlur: {
            type: Boolean,
            default: false,
            required: false,
        },
        size: {
            type: String,
            default: 'xxxl',
        },
    },

    data() {
        return {
            sizeClass: {
                'max-w-md': this.size === 'md',
                'max-w-lg': this.size === 'lg',
                'max-w-xl': this.size === 'xl',
                'max-w-2xl': this.size === 'xxl',
                'max-w-3xl': this.size === 'xxxl',
            },
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
